import Header from 'components/Header';
import { Box, useTheme, Tabs, Tab } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { colorTheme } from '../../theme';
import PlanChangeRequests from './PlanChanges';
import WithdrawalRequests from './Withdrawals';
import { type ITabPanelProps } from 'types';
import { getTabIndexFromLocalStorage } from 'utils/GeneralUtil';
import TransferInRequests from './TransferIn';
import TransferOutRequests from './TransferOut';

function TabPanel(props: ITabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, height: '75vh' }}>{children}</Box>}
    </div>
  );
}

const Requests = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  /* Tab Menu */
  const [value, setValue] = useState<number>(
    getTabIndexFromLocalStorage('selectedRequestTab'),
  );
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  useEffect(() => {
    const storedTab = sessionStorage.getItem('selectedRequestTab');
    if (storedTab) {
      sessionStorage.removeItem('selectedRequestTab');
    }
  }, []);
  return (
    <Box>
      <Header title="Requests" />

      {/* Seporator */}
      <Box py={2} />

      {/* GRID & CHARTS */}
      <Box
        sx={{
          maxWidth: {
            xs: 320,
            sm: 480,
            md: '100%',
          },
          borderRadius: 3,
          px: 2,
          boxShadow: 2,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="secondary"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: colors.greenAccent[600],
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[500],
            },
          }}
        >
          <Tab label="Plan Change Requests" />
          <Tab label="Withdrawal Requests" />
          <Tab label="Transer IN Requests" />
          <Tab label="Transfer Out Requests" />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <PlanChangeRequests />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <WithdrawalRequests />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <TransferInRequests />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <TransferOutRequests />
      </TabPanel>
    </Box>
  );
};

export default Requests;
